/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding initialization code.
 * Use "quasar new plugin <name>" and add it there.
 * One plugin per concern. Then reference the file(s) in quasar.conf.js > plugins:
 * plugins: ['file', ...] // do not add ".js" extension to it.
 **/
import './quasar'

import Vue from 'vue'
Vue.config.productionTip = false


import 'quasar-extras/roboto-font'

import 'quasar-extras/material-icons'



import 'quasar-extras/animate/zoomIn.css'

import 'quasar-extras/animate/zoomOut.css'

import 'quasar-extras/animate/fadeIn.css'

import 'quasar-extras/animate/fadeOut.css'


import 'quasar-app-styl'


import 'src/css/app.styl'

import 'src/css/progress.css'

import 'src/css/anim.css'

import 'src/css/panel.css'

import 'src/css/icomoon.css'

import 'src/css/editor.css'


import App from 'src/App'

import router from 'src/router'

import store from 'src/store'


const app = {
  el: '#q-app',
  router,
store,
  ...App
}


const plugins = []

import pluginI18n from 'src/plugins/i18n'
plugins.push(pluginI18n)

import pluginAxios from 'src/plugins/axios'
plugins.push(pluginAxios)

import pluginVuelidate from 'src/plugins/vuelidate'
plugins.push(pluginVuelidate)

import pluginFilters from 'src/plugins/filters'
plugins.push(pluginFilters)

import pluginUtils from 'src/plugins/utils'
plugins.push(pluginUtils)

import pluginCopy from 'src/plugins/copy'
plugins.push(pluginCopy)

import pluginClipboard from 'src/plugins/clipboard'
plugins.push(pluginClipboard)

import pluginWebsocket from 'src/plugins/websocket'
plugins.push(pluginWebsocket)

import pluginFontawesomefree from 'src/plugins/fontawesome-free'
plugins.push(pluginFontawesomefree)

plugins.forEach(plugin => plugin({ app, router, store, Vue }))









new Vue(app)






// WEBPACK FOOTER //
// ./.quasar/entry.js